var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-empty-data"},[_c('img',{attrs:{"src":_vm.getIcon,"alt":"Empty data"}}),_c('span',[_vm._v(_vm._s(_vm.resolvedEmptyText))]),(_vm.emptySubText)?_c('span',{staticClass:"sub-text"},[_vm._v(_vm._s(_vm.emptySubText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }